import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatOption } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Subscription } from 'rxjs';
import { debounceTime, filter, finalize } from 'rxjs/operators';
import {
    IAvailableTypes,
    IConstantItem,
} from 'src/app/core/models/available-types.interface';
import { PageParams } from 'src/app/core/models/page-params.model';
import { ConstantService } from 'src/app/core/services/constant.service';
import { MarketplacesService } from 'src/app/core/services/marketplaces.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { UploadFileService } from 'src/app/core/services/upload-file.service';
import { UserService } from 'src/app/core/services/user.service';
import { ConfirmPopupDialog } from 'src/app/shared/popups/confirm-popup/confirm-popup.component';
import { CustomerPopupDialog } from 'src/app/shared/popups/customer-popup/customer-popup.component';
import { RegistrationService } from '../../customer-registration/services/registration.service';
import { ConfirmAssignComponent } from '../../invoice-manager/components/confirm-assign/confirm-assign.component';
import { SpecificInvoiceListDialogComponent } from '../../invoice-manager/components/specific-invoice-list-dialog/specific-invoice-list-dialog.component';
import { EAssignType } from '../../invoice-manager/editor/editor.component';
import { InvoiceManagementService } from '../../invoice-manager/invoice-management.service';
import { IOrderListItem } from '../models/order-list-item';
import { ISaleOrder } from '../models/sale-order.interface';
import { SaleOrderService } from '../services/sale-order.service';
import { SaleOrderDetailsComponent } from './sale-order-details/sale-order-details.component';
import { FieldList } from './hideshow-fields-param';
import { HideShowFieldsComponent } from 'src/app/shared/popups/hideshow-fields/hideshowfields.component';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { ConsolidateShipmentsDetailsComponent } from '../../consolidate-shipments/components/consolidate-shipments-details/consolidate-shipments-details.component';
import * as _ from 'lodash';
import { SaleOrderStatus } from 'src/app/shared/enums/sale-order-status.enum';
import { SaleOrderType } from 'src/app/shared/enums/sale-order-type.enum';
import { ICountry } from 'src/app/core/models/country.interface';
import { LocalStorageService } from '../../empact-shop/core/services/local-storage.service';
import { PlaceStatus } from '../../../shared/enums/place-status.enum';
import { XlsxUploadPopupPopupComponent } from '../invat-order-search-page/xlsx-upload-popup/xlsx-upload-popup.component';
import { OriginCountryPopupDialog } from 'src/app/shared/popups/origin-country/origin-country-popup.component';
import { MatSelect } from '@angular/material/select';
import { Roles } from 'src/app/shared/enums/role-types.enum';
import { ShipmentSubtypeSelectPopupComponent } from 'src/app/shared/popups/shipment-subtype-select-popup/shipment-subtype-select-popup.component';
import { ConsolidateShipmentService } from 'src/app/core/services/consolidate-shipments.service';
import { BatchService } from '../../batch/service/batch.service';
import { PartnerService } from '../../partner-management/services/partner.service';
import { deliveredStatuses } from 'src/app/core/constants.enum';
import {
    IStatusType,
    SaleOrderStatusCategory,
} from '../models/status-type.interface';
import { DeliveryStatusLabelPipe } from 'src/app/shared/pipes/delivery-status-label.pipe';
import {
    ParcelStatus
} from "../../consolidate-shipments/components/consolidate-shipments-details/consolidate-shipment-packages/consolidate-shipment-packages.component";
import {IParcelItem} from "../models/parcel-item";
import { buildSaleOrderExportColumns, resolveEffectiveFieldListForExport } from '../utils/sale-order-export-columns.util';
import { SaleOrderExportPollerService } from '../services/sale-order-export-poller.service';
import { ExportProgressDialogComponent } from './export-progress-dialog/export-progress-dialog.component';

const Field_List: FieldList[] = [
    {
        key: 'reorder',
        value: false,
        label: 'Reorder',
    },
    {
        key: 'eciOrderDate',
        value: false,
        label: 'Empact Order Date',
    },
    {
        key: 'orderId',
        value: false,
        label: 'Order Id',
    },
    {
        key: 'stripeAmount',
        value: false,
        label: 'Stripe Amount',
    },
    {
        key: 'stripeRefundAmount',
        value: false,
        label: 'Stripe Refund Amount',
    },
    {
        key: 'marketplaceVat',
        value: false,
        label: 'Market place VAT',
    },
    {
        key: 'conversionRate',
        value: false,
        label: 'Conversion Rate',
    },
    {
        key: 'empactVatAmountEur',
        value: false,
        label: 'Empact VAT Amount (EUR)',
    },
    {
        key: 'empactTotalOrderAmountEur',
        value: false,
        label: 'Emapct Total Order Amount (EUR)',
    },
    {
        key: 'eciVat',
        value: false,
        label: 'Amount Exc.VAT',
    },
];

@Component({
    selector: 'eci-orders-search-page',
    templateUrl: './orders-search-page.component.html',
    styleUrls: ['./orders-search-page.component.scss'],
})
export class OrdersSearchPageComponent implements OnInit {
    pageParams: PageParams = new PageParams();
    fromData: FormControl = new FormControl('');
    toData: FormControl = new FormControl('');
    PlaceStatus = PlaceStatus;
    fromDataEmpact: FormControl = new FormControl('');
    toDataEmpact: FormControl = new FormControl('');

    deliveryFromDate: FormControl = new FormControl('');
    deliveryToDate: FormControl = new FormControl('');

    marketplaces: FormControl = new FormControl(null);
    operationalStatus: FormControl = new FormControl(null);
    financialStatus: FormControl = new FormControl(null);
    orderStatus: FormControl = new FormControl(null);
    //customerType: FormControl = new FormControl(null); // Deprecate Company type
    searchStr = new FormControl('');
    searchorMarketplaces: FormControl = new FormControl('');
    searchOperationalStatus: FormControl = new FormControl('');
    searchFinancialStatus: FormControl = new FormControl('');
    searchorderStatus: FormControl = new FormControl('');
    operationalStatusOptions: IStatusType[] = [];
    financialStatusOptions: IStatusType[] = [];
    //searchcustomerType: FormControl = new FormControl(''); // Deprecate Company type
    searchCustomerName: FormControl = new FormControl('');
    customerName: FormControl = new FormControl('');
    amountType: FormControl = new FormControl('');

    batchOriginCountry: FormControl = new FormControl('');
    batchDestinationCountry: FormControl = new FormControl('');

    originCountry: FormControl = new FormControl('');
    originSearchCountry = new FormControl('');
    syncStatus = new FormControl(null);
    availableOriginCountries: ICountry[];
    batchIdfilter: FormControl = new FormControl(null);
    batchSearchId: FormControl = new FormControl('');

    partnerIdfilter: FormControl = new FormControl(null);
    partnerSearchId: FormControl = new FormControl('');
    partnerList = [];

    destinationCountry: FormControl = new FormControl('');
    destinationSearchCountry = new FormControl('');
    availableDestinationCountries: ICountry[];

    shopIdByfilter: FormControl = new FormControl('');
    searchShopIdDropDown = new FormControl('');
    currentSort: Sort;
    sumOfTotalFIelds: any = [];
    sumOfTotalFIeldsIncludingCancelled: any = [];
    previousUrl: string = null;
    currentUrl: string = null;
    saleOrdersList: ISaleOrder[];
    availableTypes: IAvailableTypes;
    showLoader: boolean = false;
    showBatchBtn: boolean = true;

    listOfSelectedItems: number[] = [];
    listOfSelectedItemsBody: ISaleOrder[] = [];
    existingConsolOrderIds: number[] = [];

    previousePageCustomer: number = 0;
    totalPagesCustomers: number = 0;

    companyList: any[];
    routeSubscription: Subscription;
    amountTypes: Array<object>;
    fullCountriesList: ICountry[];
    getAllShops: any = [];
    previousPageShops: number = 0;
    totalPagesShops: number = 1;
    isLoadingShops: boolean = false;
    private shopRequestId = 0;

    isSOFromXlsx: boolean = false;
    isSOFromXlsxFailed: boolean = false;
    header: string = 'Sales Management';

    fieldList = Field_List;
    addNewSaleOrder: boolean = false;
    batchIdList = [];

    fileNameFilter: FormControl = new FormControl('');
    fileNameSearchId: FormControl = new FormControl('');
    fileNameList = [];
    previousPageFileNames: number = 0;
    totalPagesFileNames: number = 1;
    isLoadingFileNames: boolean = false;
    private fileNameRequestId = 0;

    placementStatusFilter: FormControl = new FormControl('');
    placementStatusSearchId: FormControl = new FormControl('');
    placementStatusList = [];

    cursor: string | null = null;
    nextCursor: string | null = null;
    isLoading = false;
    hasMore = true;
    items: any[] = [];
    dataSource: any[] = [];

    sub$: Subscription = new Subscription();

    @ViewChild('marketplaceSelect', { static: true })
    marketplaceSelect: MatSelect;
    @ViewChild('operationalStatusSelect', { static: true })
    operationalStatusSelect: MatSelect;
    @ViewChild('financialStatusSelect', { static: true })
    financialStatusSelect: MatSelect;
    @ViewChild('orderStatusSelect', { static: true })
    orderStatusSelect: MatSelect;
    @ViewChild('shopNameSelect', { static: true }) shopNameSelect: MatSelect;
    @ViewChild('companySelect', { static: true }) companySelect: MatSelect;
    @ViewChild('originCountrySelect', { static: true })
    originCountrySelect: MatSelect;
    @ViewChild('destinationCountrySelect', { static: true })
    destinationCountrySelect: MatSelect;
    @ViewChild('fileInput') fileInput: any;

    get isAdmin(): boolean {
        return this.userSvc.isAdmin;
    }

    get isDelegateAdmin(): boolean {
        return this.userSvc.userStorage.role == Roles.DelicateAdmin;
    }

    pageChanged(e: PageParams): void {
        this.pageParams.pageIndex = e.pageIndex;
        this.pageParams.pageSize = e.pageSize;
        this.userSvc.isAdmin || this.userSvc.isDelegatedAdmin
            ? this.getList(e.pageIndex + 1, e.pageSize, this.searchStr.value)
            : this.getList(
                  e.pageIndex + 1,
                  e.pageSize,
                  this.searchStr.value,
                  this.userSvc.company.id
              );
    }

    constructor(
        private route: ActivatedRoute,
        public localStorageSvc: LocalStorageService,
        private router: Router,
        public userSvc: UserService,
        private dialog: MatDialog,
        private saleOrderSvc: SaleOrderService,
        private datePipe: DatePipe,
        private constSvc: ConstantService,
        private notify: NotificationService,
        private marketplaceSvc: MarketplacesService,
        private regSvc: RegistrationService,
        public uploadFileSvc: UploadFileService,
        private invoiceManagementService: InvoiceManagementService,
        private consolidateShipmentService: ConsolidateShipmentService,
        private batchService: BatchService,
        private partnerService: PartnerService,
        private deliveryStatusLabelPipe: DeliveryStatusLabelPipe,
        private exportPoller: SaleOrderExportPollerService,
    ) {
        this.amountTypes = [
            { id: '0', name: 'All' },
            { id: '1', name: 'up to 150' },
            { id: '2', name: 'over to 150' },
        ];
    }

    displayedColumns: string[] = [
        'checkboxes',
        'operationalStatus',
        'financialStatus',
        // 'donwloadDocuments',
        'downloadParcelLabel',
        'parcelCount',

        'reorder',
        //'hasErrors',
        'returns',
        'eciOrderDate',
        'orderDate',
        'originCountryName',
        'countryName',
        'customerName',
        // 'customerType', // Deprecate Company type
        'shopId',
        'shopName',
        'orderID',
        'morderID',
        'shipmentId',
        'carrier',
        'trackingNumber',
        'orderCurrency',
        'stripeAmount',
        'stripeRefundAmount',
        'conversionRate',
        'eciVat',
        'totalWithoutVat',
        'vatCharges',
        'empactVatAmountEur',
        'empactTotalOrderAmountEur',
        'orderAmount',
        'marketPlace',
        'deliveryDate',
        // 'orderStatus', // Hidden: legacy sale_orders.status column; use operationalStatus + financialStatus instead.

        // ADED FOR QA TEAM - NOT VISIBLE IN UI FOR USERS
        'eciSellOrderTotalTest',
        'shippingPriceTest',

        'productsTest',
        // 'syncAftershipRefresh',
    ];

    // Deprecate Company type
    // get customerTypes(): IConstantItem[] {
    //     if (!this.availableTypes) {
    //         return;
    //     }
    //     return this.availableTypes.CompanyType;
    // }

    get marketplaceTypes(): IConstantItem[] {
        return this.marketplaceSvc?.availableMarketplaces$?.getValue();
    }

    get orderStatuses(): IConstantItem[] {
        if (!this.availableTypes) {
            return;
        }
        return this.availableTypes.SaleOrderStatus;
    }

    ngOnInit(): void {
        this.loadStatusTypeFilterOptions();
        this.getListOfBatches();
        this.getListOfFileName();
        if(this.userSvc.isAdmin){
            this.getPartnersList();
            this.displayedColumns.splice(14, 0, 'batchId');
            this.displayedColumns.splice(15, 0, 'consolNumber');
            this.displayedColumns.splice(16, 0, 'batchOriginCountryName');
            this.displayedColumns.splice(17, 0, 'batchDestinationCountryName');
            this.displayedColumns.splice(18, 0, 'fileName');
            this.displayedColumns.splice(19, 0, 'batchType');
        } else {
            this.displayedColumns.splice(15, 0, 'regularConsolNumber');
        }

        this.route.data.subscribe((data) => {
            this.isSOFromXlsx = data?.isXlsx ? data.isXlsx : false;
            this.isSOFromXlsxFailed = data?.isFailed ? data.isFailed : false;
            if (this.isSOFromXlsx) {
                this.showBatchBtn = false;
                if (!this.isSOFromXlsxFailed) {
                    this.header = 'Pending Data To Sync Page';
                    this.displayedColumns.push('confirmStatus');
                } else {
                    this.header = 'DataSync Error Page';
                    this.displayedColumns.splice(2, 0, 'batchErrors');
                }
            }
        });
        this.getListOfCountries('', 1);
        this.originSearchCountry.valueChanges.subscribe((value) => {
            if (value) {
                this.availableOriginCountries = this.fullCountriesList.filter(
                    (c) => c.name.toLowerCase().includes(value.toLowerCase())
                );
            } else {
                this.availableOriginCountries = this.fullCountriesList;
            }
        });

        this.destinationSearchCountry.valueChanges.subscribe((value) => {
            if (value) {
                this.availableDestinationCountries =
                    this.fullCountriesList.filter((c) =>
                        c.name.toLowerCase().includes(value.toLowerCase())
                    );
            } else {
                this.availableDestinationCountries = this.fullCountriesList;
            }
        });

        this.searchShopIdDropDown.valueChanges
            .pipe(debounceTime(500))
            .subscribe((value) => {
                this.previousPageShops = 0;
                this.getAllShopsData(1, 20, value || '');
            });

        this.routeSubscription = this.router.events
            .pipe(filter((event) => event instanceof NavigationEnd))
            .subscribe((event: NavigationEnd) => {
                if (event.url != '/') {
                    this.previousUrl = this.currentUrl;
                    this.currentUrl = event.url;
                }
            });
        this.userSvc.isAdmin || this.userSvc.isDelegatedAdmin
            ? this.getList(1, this.pageParams.pageSize, '')
            : this.getList(1, this.pageParams.pageSize, '', this.userSvc.company.id);

        this.getAllShopsData();

        this.constSvc.availableTypes.subscribe((data) => {
            this.availableTypes = data;
        });

        this.searchStr.valueChanges
            .pipe(debounceTime(500))
            .subscribe((value) => {
                this.search();
            });

        this.getListCompanies();

        this.searchCustomerName.valueChanges
            .pipe(debounceTime(500))
            .subscribe((value) => {
                this.previousePageCustomer = 0;
                this.getListCompanies();
            });

        this.fileNameSearchId.valueChanges
            .pipe(debounceTime(500))
            .subscribe((value) => {
                this.previousPageFileNames = 0;
                this.getListOfFileName(1, 20, value || '');
            });

        this.constSvc.getAvailableCountries().subscribe((data) => {
            this.fullCountriesList = data;
        });
        this.loadStatusTypeFilterOptions();
    }

    private loadStatusTypeFilterOptions(): void {
        this.saleOrderSvc.getStatusTypes().subscribe((statusTypes: IStatusType[]) => {
            this.operationalStatusOptions = this.mapStatusOptionsForSearch(
                (statusTypes || []).filter((row) => row.statusType === SaleOrderStatusCategory.OPERATIONAL),
            );
            this.financialStatusOptions = this.mapStatusOptionsForSearch(
                (statusTypes || []).filter((row) => row.statusType === SaleOrderStatusCategory.FINANCIAL),
            );
        });
    }

    private mapStatusOptionsForSearch(options: IStatusType[]): IStatusType[] {
        return options.map((row) => ({
            ...row,
            name: this.deliveryStatusLabelPipe.transform(row.empactStatusId),
        }));
    }

    getListOfCountries(q: string, page: number, limit: number = 1000): void {
        this.constSvc
            .getAvailableCountriesForScroll(page, limit, false, q)
            .subscribe((data) => {
                if (!data) {
                    return;
                }
                this.fullCountriesList = data.items;
                this.availableOriginCountries = data.items;
                this.availableDestinationCountries = data.items;
            });
    }

    /*toggleAllSelection(control: FormControl, option: MatOption, countries: ICountry[]) {
        if (option.selected) {
            control
                .patchValue([...countries.map(item => item.name), 0]);
        } else {
            control.patchValue([]);
        }
    }

    toggleAllEUSelection(control: FormControl, option: MatOption, countries: ICountry[]) {
        if (option.selected) {
            const selectedCountries = [];
            countries.map(item => {
                if (item.name !== 'United Kingdom' && item.isEurope) {
                    selectedCountries.push(item.name);
                }
            })
            control
                .patchValue([...selectedCountries, 1]);
        } else {
            control.patchValue([]);
        }
    }*/

    getAllShopsData(
        page: number = this.previousPageShops + 1,
        limit: number = 20,
        q: string = this.searchShopIdDropDown.value
    ): void {
        if (page > 1 && (this.isLoadingShops || this.previousPageShops >= this.totalPagesShops)) {
            return;
        }
        const requestId = ++this.shopRequestId;
        this.isLoadingShops = true;
        this.saleOrderSvc.getAllShops(q || '', page, limit).subscribe(
            (result) => {
                if (requestId !== this.shopRequestId) {
                    return;
                }
                const items = Array.isArray(result) ? result : result?.items || [];
                const meta = result?.meta;
                if (meta?.currentPage > 1) {
                    const existingKeys = new Set(
                        this.getAllShops.map((shop) => this.getValueShopNameFilter(shop))
                    );
                    this.getAllShops = [
                        ...this.getAllShops,
                        ...items.filter(
                            (shop) => !existingKeys.has(this.getValueShopNameFilter(shop))
                        ),
                    ];
                } else {
                    this.getAllShops = this.keepSelectedShops(items);
                }
                this.previousPageShops = meta?.currentPage || page;
                this.totalPagesShops = meta?.totalPages || 1;
                this.isLoadingShops = false;
            },
            () => {
                if (requestId === this.shopRequestId) {
                    this.isLoadingShops = false;
                }
            }
        );
    }

    onShopDropdownOpened(): void {
        this.previousPageShops = 0;
        this.getAllShopsData(1, 20, this.searchShopIdDropDown.value || '');
    }

    private keepSelectedShops(shops: any[] = []): any[] {
        const selectedValues = this.shopIdByfilter?.value;
        if (!selectedValues || (Array.isArray(selectedValues) && selectedValues.length === 0)) {
            return shops;
        }
        const values = Array.isArray(selectedValues) ? selectedValues : [selectedValues];
        const selected = this.getAllShops.filter(
            (shop) =>
                values.some((value) => value == this.getValueShopNameFilter(shop)) &&
                !shops.some(
                    (item) => this.getValueShopNameFilter(item) === this.getValueShopNameFilter(shop)
                )
        );
        return selected.length ? [...shops, ...selected] : shops;
    }

    trackByShopId(index: number, shop: any): number | string {
        return shop?.id ?? shop?.shopId ?? index;
    }

    trackByCompanyId(index: number, company: any): number | string {
        return company?.id ?? index;
    }

    trackByFileId(index: number, file: any): number | string {
        return file?.xlsx_sale_order_files_id ?? index;
    }

    isDataNotCorrect(item: FormControl): boolean {
        return item.value === null;
    }

    getPartnersList(): void {
        this.partnerService.getPartnersList().subscribe((result) => {
            this.partnerList = result;
        });
    }


    getList(
        page: number = this.pageParams.pageIndex + 1,
        limit: number = this.pageParams.pageSize,
        q: string = this.searchStr.value,
        companyId: number = this.customerName.value,
        isSelectAll: boolean = false,
        batchId: number = this.batchIdfilter.value,
        partnerId: number = this.partnerIdfilter.value,
        fileId: number = this.fileNameFilter.value,
        batchCountryOrigin: string = this.batchOriginCountry.value,
        batchCountryDestination: string = this.batchDestinationCountry.value,
        amountType: string = this.amountType.value,
        originCountry: string = this.originCountry.value,
        destinationCountry: string = this.destinationCountry.value,
        shopId: string = this.shopIdByfilter.value,
        orderField: string = this.currentSort?.active || '',
        orderDir: string = this.currentSort?.direction.toUpperCase() || '',
        placeStatus: PlaceStatus = this.syncStatus?.value ? this.syncStatus?.value : (
            this.isSOFromXlsx === true && this.isSOFromXlsxFailed === false ?
            [PlaceStatus.Confirmed, PlaceStatus.Pending, PlaceStatus.Confirmed_Warning] :
            this.isSOFromXlsxFailed === true ? PlaceStatus.Failed : ''
        )
    ): void {
        if (!isSelectAll && this.isLoading) {
            return;
        }
        this.isLoading = true;
        this.showLoader = true;
        this.saleOrderSvc.getOrdersB2CTest(
            page,
            limit,
            q,
            companyId,
            batchId,
            partnerId,
            fileId,
            amountType,
            '',
            shopId,
            this.prepareSearchParams,
            orderField,
            orderDir,
            false,
            this.isSOFromXlsx ? SaleOrderType.All.toString() : SaleOrderType.IsB2C.toString(),
            false,
            this.isSOFromXlsxFailed ? PlaceStatus.Failed : placeStatus,
            {
                originCountry,
                destinationCountry,
                batchCountryOrigin,
                batchCountryDestination,
                dateToEmpact: this.toDataEmpact.value
                    ? this.datePipe.transform(this.toDataEmpact.value, 'yyyy-MM-dd')
                    : '',
                dateFromEmpact:
                    this.toDataEmpact.value && this.fromDataEmpact.value
                        ? this.datePipe.transform(this.fromDataEmpact.value, 'yyyy-MM-dd')
                        : '',
                deliveryDateTo: this.deliveryToDate.value
                    ? this.datePipe.transform(this.deliveryToDate.value, 'yyyy-MM-dd')
                    : '',
                deliveryDateFrom:
                    this.deliveryFromDate.value &&
                    this.deliveryFromDate.value
                        ? this.datePipe.transform(this.deliveryFromDate.value, 'yyyy-MM-dd')
                        : '',
            },
            isSelectAll
        )
        .subscribe({
            next: (data) => {
                this.isLoading = false;
                this.showLoader = false;

                if (!data) return;

                // duplicates logic — unchanged
                this.checkDuplicates(data);

                this.dataSource = data.items;

                if (isSelectAll) {
                    this.listOfSelectedItems = this.dataSource.map(item => item.id);
                    this.listOfSelectedItemsBody = [];
                    return;
                }

                this.saleOrdersList = this.dataSource;

                this.pageParams.pageSize = data.meta.itemsPerPage;
                this.pageParams.pageIndex = data.meta.currentPage - 1;
                this.pageParams.length = data.meta.totalItems;
            },
            error: (err) => {
                console.error('sale Order error:', err);
                this.isLoading = false;
                this.showLoader = false;
            }
        });
    }

    private getValue = <T>(obj: T, path: string) => path.split('.')
        .reduce((o, p) => (o ? o[p] : null), obj)

    private sortDataSource<T>(data: T[], fieldPath: string, direction: 'ASC' | 'DESC'): T[] {
        const dir = direction === 'ASC' ? 1 : -1;

        return data.sort((a: T, b: T) => {
            const v1 = this.getValue(a, fieldPath);
            const v2 = this.getValue(b, fieldPath);

            if (v1 === null) {
                return 1 * dir;
            }
            if (v2 === null) {
                return -1 * dir;
            }

            if (v1 instanceof Date || v2 instanceof Date || !isNaN(Date.parse(v1))) {
                return (new Date(v1).getTime() - new Date(v2).getTime()) * dir;
            }

            if (typeof v1 === 'number' && typeof v2 === 'number') {
                return (v1 - v2) * dir;
            }

            return String(v1)
                .localeCompare(String(v2)) * dir;
        });
    }

   private checkDuplicates(data): void {
        const duplicates = this.findDuplicate(data.items);
        for (const item of data.items) {
            if (duplicates.length > 0) {
                const marketplaceOrderId =
                    item?.marketplace?.marketplaceOrderId?.length > 6
                        ? item?.marketplace?.marketplaceOrderId?.slice(-5)
                        : item?.marketplace?.marketplaceOrderId;

                if (duplicates.indexOf(marketplaceOrderId) > -1) {
                    item['color'] = '#eba5a5';
                }
            }
        }
    }

    openDialog(): void {
        const dialogRef = this.dialog.open(SaleOrderDetailsComponent, {
            maxHeight: '600px',
            width: '900px',
        });
        dialogRef.componentInstance.createMode = true;
        dialogRef.componentInstance.isB2BSaleOrder = false;
        dialogRef.componentInstance.header =
            'Sales Management - Add Sales Order';
        dialogRef.componentInstance.marginTop = '0';
        dialogRef.afterClosed().subscribe((result) => {
            this.userSvc.isAdmin || this.userSvc.isDelegatedAdmin
                ? this.getList(1, this.pageParams.pageSize, '')
                : this.getList(1, this.pageParams.pageSize, '', this.userSvc.company.id);
        });
    }

    get prepareSearchParams(): any {
        return {
            marketplaces: this.marketplaces.value
                ? this.marketplaces.value
                : '',
            //companyTypes: this.customerType.value ? this.customerType.value : '',// Deprecate Company type
            dateTo:
                this.toData.value && this.toData.value !== null
                    ? this.datePipe.transform(this.toData.value, 'yyyy-MM-dd')
                    : '',
            dateFrom:
                this.toData.value && this.fromData.value !== null
                    ? this.datePipe.transform(this.fromData.value, 'yyyy-MM-dd')
                    : '',
            orderStatus: this.orderStatus.value ? this.orderStatus.value : '',
            operationalStatus: this.operationalStatus.value ?? '',
            financialStatus: this.financialStatus.value ?? '',
        };
    }

    sortData(sort: Sort): void {
        const data = this.saleOrdersList.slice();
        if (!sort.active || sort.direction === '') {
            this.saleOrdersList = data;
            this.dataSource = data;
            return;
        }

        this.dataSource = [];
        this.saleOrdersList = [];
        this.pageParams.pageIndex = 0;

        this.currentSort = sort;
        this.getList(
            1,
            this.pageParams?.pageSize,
            this.searchStr.value || '',
            ((this.userSvc.isAdmin || this.userSvc.isDelegatedAdmin)
                ? this.customerName.value
                : this.userSvc.company.id));
    }

    search(): void {
        this.dataSource = [];
        this.saleOrdersList = [];
        this.pageParams.pageIndex = 0;
        // cleaned current datasource so that result after search will be fresh
        this.getList(1, this.pageParams.pageSize,
            this.searchStr.value,
            ((this.userSvc.isAdmin || this.userSvc.isDelegatedAdmin)
                ? this.customerName.value
                : this.userSvc.company.id));
    }

    deleteOrders(): void {
        if (!this.listOfSelectedItems) {
            return;
        }
        const dialogRef = this.dialog.open(ConfirmPopupDialog);
        dialogRef.componentInstance.message = 'Please confirm deleting';
        dialogRef.componentInstance.rightBtnText = 'Delete';
        dialogRef.afterClosed().subscribe((value) => {
            if (!value) {
                return;
            }

            this.saleOrderSvc.deleteOrders(this.listOfSelectedItems).subscribe(
                () => {
                    this.listOfSelectedItems = [];
                    this.listOfSelectedItemsBody = [];
                    this.dataSource = [];
                    this.saleOrdersList = [];
                    this.getList();
                    this.notify.showSuccessMessage('Deleted successfully');
                },
                (err) => {
                    this.notify.showSuccessMessage('Something went wrong');
                    console.log('Error => ', err);
                }
            );
        });
    }

    regenerateOrdersInvoice(): void {
        if (!this.listOfSelectedItems) {
            return;
        }
        const dialogRef = this.dialog.open(ConfirmPopupDialog);
        dialogRef.componentInstance.message =
            'Please confirm regeneration of invoice';
        dialogRef.componentInstance.rightBtnText = 'Regenerate Invoice';
        dialogRef.afterClosed().subscribe((value) => {
            if (!value) {
                return;
            }

            this.saleOrderSvc
                .regenrateOrdersInvoice(this.listOfSelectedItems)
                .subscribe(
                    (res) => {
                        this.getList();
                        this.listOfSelectedItems = [];
                        this.notify.showSuccessMessage(res?.message);
                    },
                    (err) => {
                        this.notify.showSuccessMessage('Something went wrong');
                        console.log('Error => ', err);
                    }
                );
        });
    }

    deleteDuplicateds(): void {
        if (!this.customerName?.value) {
            return;
        }
        const dialogRef = this.dialog.open(ConfirmPopupDialog);
        dialogRef.componentInstance.message = 'Please confirm deleting';
        dialogRef.componentInstance.rightBtnText = 'Delete';
        dialogRef.afterClosed().subscribe((value) => {
            if (!value) {
                return;
            }

            this.saleOrderSvc
                .deleteMultipleOrder({ companyId: this.customerName?.value })
                .subscribe(
                    () => {
                        this.getList();
                        this.listOfSelectedItems = [];
                        this.notify.showSuccessMessage('Deleted successfully');
                    },
                    (err) => {
                        this.notify.showSuccessMessage('Something went wrong');
                        console.log('Error => ', err);
                    }
                );
        });
    }

    getListCompanies(q: string = this.searchCustomerName.value): void {
        q = this.customerName.value ? this.searchCustomerName.value : q;
        this.regSvc.getCompanyListForSales(q).subscribe((data) => {
            if (!data) {
                return;
            }
            this.companyList = data;
        });
    }

    clearSelection() {
        this.customerName.reset();
        this.getListCompanies(this.searchCustomerName.value);
        this.listOfSelectedItems =[];
        this.listOfSelectedItemsBody = [];
    }

    downloadDoc(element): void {
        this.saleOrderSvc.downloadFile(element?.id, element?.orderDocumentsId);
    }

    uploadDoc(el: {
        saleOrderId: number;
        id: number;
        e: any;
        file: any;
    }): void {
        const files = el.e.dataTransfer
            ? el.e.dataTransfer.files
            : el.e.target.files;

        this.saleOrderSvc.fileLoadedObserver.subscribe(() => {
            // this.getList();
            this.userSvc.isAdmin || this.userSvc.isDelegatedAdmin
                ? this.getList(1, this.pageParams.pageSize, '')
                : this.getList(1, this.pageParams.pageSize, '', this.userSvc.company.id);
        });

        this.saleOrderSvc.uploadFile(files, el.saleOrderId, el.id);
    }

    updateDocs(id, body, element): void {
        this.saleOrderSvc
            .updateOrderDoc(element?.id, id, body)
            .subscribe((data) => {
                this.notify.showSuccessMessage('Document Uploaded');
            });
    }

    public exportToExcel(): void {
        if (this.exportPoller.isExportInProgress) {
            this.dialog.open(ExportProgressDialogComponent, {
                width: '440px',
                disableClose: true,
                data: { alreadyInProgress: true },
            });
            return;
        }

        // Match getList() placeStatus exactly so export row count matches pagination total.
        let placeStatus: any = this.syncStatus?.value
            ? this.syncStatus.value
            : (this.isSOFromXlsx === true && this.isSOFromXlsxFailed === false
                ? [PlaceStatus.Confirmed, PlaceStatus.Pending, PlaceStatus.Confirmed_Warning]
                : (this.isSOFromXlsxFailed === true ? PlaceStatus.Failed : ''));
        if (this.isSOFromXlsxFailed) {
            placeStatus = PlaceStatus.Failed;
        }

        const exportColumns = buildSaleOrderExportColumns({
            displayedColumns: this.displayedColumns,
            fieldList: resolveEffectiveFieldListForExport(
                this.fieldList,
                'SALES_ORDER_VISIBLITY_FIELD_RULE',
                this.localStorageSvc,
            ),
            isAdmin: this.userSvc.isAdmin,
            isDelegateAdmin: this.userSvc.isDelegatedAdmin,
            isB2B: false,
        });

        const companyId = this.userSvc.isAdmin || this.userSvc.isDelegatedAdmin
            ? this.customerName.value
            : this.userSvc.company.id;
        const isB2B = this.isSOFromXlsx
            ? SaleOrderType.All.toString()
            : SaleOrderType.IsB2C.toString();
        const orderField = this.currentSort?.active || '';
        const orderDirection = this.currentSort?.direction
            ? this.currentSort.direction.toUpperCase()
            : '';

        const extraFilters = {
            originCountry: this.originCountry.value,
            destinationCountry: this.destinationCountry.value,
            batchCountryOrigin: this.batchOriginCountry.value,
            batchCountryDestination: this.batchDestinationCountry.value,
            dateToEmpact: this.toDataEmpact.value
                ? this.datePipe.transform(this.toDataEmpact.value, 'yyyy-MM-dd')
                : '',
            dateFromEmpact:
                this.toDataEmpact.value && this.fromDataEmpact.value
                    ? this.datePipe.transform(this.fromDataEmpact.value, 'yyyy-MM-dd')
                    : '',
            amountType: this.amountType.value,
            ShopId: this.shopIdByfilter.value,
            customerCountry: '',
            deliveryDateTo: this.deliveryToDate.value
                ? this.datePipe.transform(this.deliveryToDate.value, 'yyyy-MM-dd')
                : '',
            deliveryDateFrom:
                this.deliveryFromDate.value && this.deliveryFromDate.value
                    ? this.datePipe.transform(this.deliveryFromDate.value, 'yyyy-MM-dd')
                    : '',
        };

        let start$;
        if (this.listOfSelectedItems?.length > 0) {
            const selectedIds = [...this.listOfSelectedItems];
            start$ = this.saleOrderSvc.startExportAsync(
                {
                    companyId: companyId ? companyId : '',
                    isB2B,
                    placeStatus,
                },
                {
                    itemIds: selectedIds,
                    ...(exportColumns?.length ? { exportColumns } : {}),
                },
            );
            this.listOfSelectedItems = [];
        } else {
            const query = this.saleOrderSvc.buildSaleOrderExportQuery(
                this.pageParams?.pageIndex + 1,
                this.searchStr.value,
                companyId,
                this.prepareSearchParams,
                orderField,
                orderDirection,
                false,
                isB2B,
                undefined,
                placeStatus,
                false,
                {
                    ...extraFilters,
                    batchId: this.batchIdfilter?.value || '',
                    batchPartnerId: this.partnerIdfilter?.value || '',
                    fileId: this.fileNameFilter?.value || '',
                },
                false,
            );
            start$ = this.saleOrderSvc.startExportAsync(
                query,
                exportColumns?.length ? { exportColumns } : {},
            );
        }

        this.exportPoller.prepareNewExport();
        this.dialog.open(ExportProgressDialogComponent, {
            width: '440px',
            disableClose: true,
            data: { alreadyInProgress: false },
        });
        this.exportPoller.startJobAndTrack(start$);
    }

    openHideShowFieldsPopup(): void {
        const dialogRef = this.dialog.open(HideShowFieldsComponent, {
            width: '500px',
            data: {
                fields: this.fieldList,
                settingName: 'SALES_ORDER_VISIBLITY_FIELD_RULE',
            },
        });
        dialogRef.afterClosed().subscribe((result) => {
            if (!result) {
                return;
            }
            this.userSvc.hiddenFieldEvent.next("updates");
            this.fieldList = result;
            this.dataSource = [];
            this.saleOrdersList = [];
            this.nextCursor = null;
            this.hasMore = true;
            this.getList();
        });
    }

    clearFilters(): void {
        this.searchStr = new FormControl('');
        this.fromData = new FormControl('');
        this.fromDataEmpact = new FormControl('');
        this.toData = new FormControl('');
        this.toDataEmpact = new FormControl('');
        this.marketplaces = new FormControl(null);
        this.operationalStatus = new FormControl(null);
        this.financialStatus = new FormControl(null);
        this.orderStatus = new FormControl(null);
        this.customerName = new FormControl('');
        this.amountType = new FormControl('');
        this.originCountry = new FormControl('');
        this.destinationCountry = new FormControl('');
        this.shopIdByfilter = new FormControl('');
        this.deliveryFromDate = new FormControl('');
        this.deliveryToDate = new FormControl('');
        this.batchIdfilter = new FormControl('');
        this.fileNameFilter = new FormControl('');
        this.partnerIdfilter = new FormControl('');
        this.syncStatus=new FormControl(null);
        this.search();
    }

    findDuplicate(data) {
        const marketplaceOrderId = data.map((item) =>
            item?.marketplace?.marketplaceOrderId?.length > 6
                ? item?.marketplace?.marketplaceOrderId?.slice(-5)
                : item?.marketplace?.marketplaceOrderId
        );
        return marketplaceOrderId.filter(
            (item, index) => marketplaceOrderId.indexOf(item) !== index
        );
    }

    addNewSO(data) {
        this.consolidateShipmentService
            .getShipmentById(data)
            .subscribe((res) => {
                if (res) {
                    this.addNewSaleOrder = true;
                    this.consolidateShipments(res);
                }
            });
    }

    listUpdated(){
        // console.log('batch created from SO');
        this.getList();
    }

    consolidateShipments(data = null): void {
        //   const saleOrders = this.listOfSelectedItemsBody;
        const saleOrders = this.saleOrdersList.filter((so) =>
            this.listOfSelectedItems.includes(so.id)
        );

        const ids = [...this.listOfSelectedItems];

        if (
            !!saleOrders.find(
                (el) =>
                    el.consolNumber !== null &&
                    el.consolNumber !== undefined &&
                    !this.addNewSaleOrder
            )
        ) {
            this.notify.showError(
                'Selected items contain sale order which included to another Consol Shipment'
            );

            return;
        }

        // TO DO - Need to move all validations to backend
        const hasFinalized = saleOrders.some(el => 
            deliveredStatuses.includes(el.status) || 
            el.status === SaleOrderStatus.CANCELED
        );

        // Check for any active orders (Not in the Delivered group and not Canceled)
        const hasActive = saleOrders.some(el => 
            !deliveredStatuses.includes(el.status) && 
            el.status !== SaleOrderStatus.CANCELED
        );

        if (hasFinalized && hasActive) {
            this.notify.showError(
                'Consolidate shipment could not combine Delivered or Canceled SO with other'
            );
            return;
        }

        if (
            !!saleOrders.find((el) => {
                if (!el.linkedSaleOrderId) {
                    return false;
                } else {
                    return !!saleOrders.find(
                        (val) => val.id === el.linkedSaleOrderId
                    );
                }
            })
        ) {
            this.notify.showError(
                'Consolidate shipment could not combine Origin and Canceled / Refunded SOs'
            );
            return;
        }

        if (saleOrders.some(el => deliveredStatuses.includes(el.status))) {
            this.notify.showError(
                'Delivered sale orders cannot be consolidated'
            );
            return;
        }

        /*if (!!saleOrders.find(el => (el.shipmentConsol !== null && el.shipmentConsol !== undefined))) {
            this.notify.showError('Selected items contain sale order which included to another Consol Shipment');
            return;
        }*/

        const hasEUCountry = !!saleOrders.find(
            (el) => el.shippingCountry !== 'United Kingdom'
        );
        const hasUKCountry = !!saleOrders.find(
            (el) => el.shippingCountry === 'United Kingdom'
        );

        if (hasEUCountry && hasUKCountry) {
            this.notify.showError(
                'Shipments with destination country UK can not be consolidated to shipments with country from EU'
            );
            return;
        }

        if (this.addNewSaleOrder) {
            this.saleOrderSvc.getMultipleSOByIds(ids).subscribe((so) => {
                const dialogRef = this.dialog.open(
                    ConsolidateShipmentsDetailsComponent,
                    { width: '90vw', height: '80vh' }
                );
                dialogRef.componentInstance.summaryPage = false;
                dialogRef.componentInstance.existingConsolId = data?.id;
                dialogRef.componentInstance.info = data;
                dialogRef.componentInstance.createMode = true;
                dialogRef.componentInstance.isEditable = !!data?.id;
                dialogRef.componentInstance.saleOrders = _.cloneDeep(so);
                dialogRef.componentInstance.existingSaleOrderIds = this.existingConsolOrderIds;
                dialogRef.componentInstance.soOrderType = SaleOrderType.IsB2C;
                dialogRef.componentInstance.subtype = data?.subtype;

                dialogRef.afterClosed().subscribe((result: any) => {
                    if (
                        result.type == 'summaryPage' &&
                        result.status == 'open'
                    ) {
                        this.summaryDialog(result.data, so);
                    }
                });
            });
        } else {
            const confirmDialog = this.dialog.open(
                ShipmentSubtypeSelectPopupComponent
            );
            confirmDialog.componentInstance.isOnlyReturn = saleOrders.some(el => 
                deliveredStatuses.includes(el.status) || 
                el.status === SaleOrderStatus.CANCELED
            );

            confirmDialog.afterClosed().subscribe((value) => {
                if (value === undefined) {
                    return;
                }

                this.saleOrderSvc.getMultipleSOByIds(ids).subscribe((so) => {
                    const dialogRef = this.dialog.open(
                        ConsolidateShipmentsDetailsComponent,
                        { width: '90vw', height: '80vh' }
                    );
                    dialogRef.componentInstance.summaryPage = false;
                    dialogRef.componentInstance.info = data;
                    dialogRef.componentInstance.createMode = true;
                    dialogRef.componentInstance.saleOrders = _.cloneDeep(so);
                    dialogRef.componentInstance.soOrderType =
                        SaleOrderType.IsB2C;
                    dialogRef.componentInstance.subtype = value;

                    dialogRef.afterClosed().subscribe((result: any) => {
                        if (
                            result.type == 'summaryPage' &&
                            result.status == 'open'
                        ) {
                            this.summaryDialog(result.data, so);
                        }
                    });
                });
            });
        }
    }

    summaryDialog(data, so) {
        //  const saleOrders = this.saleOrdersList.filter((so) => this.listOfSelectedItems.includes(so.id));

        const dialogRef = this.dialog.open(
            ConsolidateShipmentsDetailsComponent,
            { width: '1000px', height: '600px' }
        );
        dialogRef.componentInstance.createMode = false;
        dialogRef.componentInstance.summaryPage = true;
        dialogRef.componentInstance.info = data;
        dialogRef.componentInstance.saleOrders = _.cloneDeep(so);
        dialogRef.componentInstance.existingSaleOrderIds = this.existingConsolOrderIds;
        dialogRef.afterClosed().subscribe((result: any) => {
            if (result.type == 'createPage' && result.status == 'open') {
                this.consolidateShipments(result.data);
            }
        });
    }

    protected changeCurrentListDisplayedColumns(
        currentExistName: string,
        newNextValue: string
    ): void {
        if (!currentExistName || !newNextValue) {
            return;
        }
        this.displayedColumns = this.displayedColumns.reduce(
            (arr, currentValue) => {
                if (currentValue === currentExistName) {
                    return [...arr, currentValue, newNextValue];
                }
                return [...arr, currentValue];
            },
            []
        );
    }

    openUploadDialog(): void {
        this.dialog.open(XlsxUploadPopupPopupComponent);
    }

    changeSOStatus(): void {
        if (!this.listOfSelectedItems) {
            return;
        }
        this.saleOrderSvc
            .confirmOrder(this.listOfSelectedItems.map((el) => Number(el)))
            .subscribe((val) => {
                this.getList();
                this.saleOrderSvc.unselectCheckbox.next('update');
                this.notify.showSuccessMessage(
                    'Confirmed. Moved to respective Sale orders table.'
                );
            });
    }

    applyChanges(): void {
        if (!this.listOfSelectedItems.length) {
            this.notify.showError('Please select at least one SO');
            return;
        }

        let dialogRef = this.dialog.open(OriginCountryPopupDialog);

        dialogRef.componentInstance.countries = this.fullCountriesList;
        dialogRef.componentInstance.orderIds = this.listOfSelectedItems.map(
            (el) => Number(el)
        );

        dialogRef.afterClosed().subscribe((value) => {
            this.listOfSelectedItems = [];
            this.getList();
        });
    }

    public selectAllData(): void {
        this.dataSource = [];
        this.saleOrdersList = [];
        this.getList(
            1,
            -1,
            this.searchStr.value,
            this.userSvc.isAdmin || this.userSvc.isDelegatedAdmin
                ? this.customerName.value
                : this.userSvc.company.id,
            true,
        );
    }

    recalculateTaxReport() {
        this.showLoader = true;
        this.saleOrderSvc
            .recalculateTaxReport(this.listOfSelectedItems)
            .subscribe((res) => {
                this.getList();
                this.listOfSelectedItems = [];
                this.notify.showSuccessMessage(
                    'Recalculation complete successfully.'
                );
            });
    }

    syncWithAfterShip(event) {
        this.showLoader = true;
        const ids = event ? [event] : this.listOfSelectedItems;
        this.saleOrderSvc.syncWithAfterShip(ids).subscribe(
            (res) => {
                this.getList();
                this.listOfSelectedItems = [];
                this.notify.showSuccessMessage(
                    'Synchronization with AfterShip complete successfully.'
                );
            },
            (error) => {
                this.showLoader = false;
            }
        );
    }

    createSpecificInvoice() {
        const dialogRef = this.dialog.open<SpecificInvoiceListDialogComponent>(
            SpecificInvoiceListDialogComponent,
            {
                maxHeight: '80vh',
                width: '890px',
                panelClass: 'inv-man-dialog',
            }
        );
        dialogRef.afterClosed().subscribe((value) => {
            if (!value) {
                return;
            }

            const selectedOrders = this.dataSource.filter((item) => {
                return this.listOfSelectedItems.includes(item.id);
            });
            const selectedTemplates = value;

            const dialogRef = this.dialog.open<ConfirmAssignComponent>(
                ConfirmAssignComponent
            );
            dialogRef.componentInstance.type = EAssignType.B2C;
            dialogRef.componentInstance.templateName = selectedTemplates
                .map((v) => v.name)
                ?.join(', ');
            dialogRef.componentInstance.selectedOrders = selectedOrders;

            dialogRef.afterClosed().subscribe((value) => {
                if (value) {
                    this.showLoader = true;
                    this.invoiceManagementService
                        .assignTemplates(
                            selectedOrders.map((o) => o.id),
                            selectedTemplates.map((v) => v.id),
                            EAssignType.B2C
                        )
                        .pipe(
                            finalize(() => {
                                this.showLoader = false;
                            })
                        )
                        .subscribe(
                            (res) => {
                                this.listOfSelectedItems = [];
                                this.notify.showSuccessMessage(
                                    'Assigning complete successfully'
                                );
                            },
                            (error) => {
                                this.notify.showError(
                                    error?.error?.message
                                        ? error.error.message
                                        : 'Something wrong!'
                                );
                            }
                        );
                }
            });
        });
    }

    getListOfBatches(
        partnerId = this.isPartner ? this.userSvc.user.id : ''
    ): void {
        this.batchService.getBatchIdList(partnerId).subscribe((result) => {
            this.batchIdList = result;
        });
    }

    get isPartner(): boolean {
        return this.userSvc.userStorage.role == Roles.PartnerAccount;
    }

    getListOfFileName(
        page: number = this.previousPageFileNames + 1,
        limit: number = 20,
        q: string = this.fileNameSearchId.value
    ): void {
        if (page > 1 && (this.isLoadingFileNames || this.previousPageFileNames >= this.totalPagesFileNames)) {
            return;
        }
        const requestId = ++this.fileNameRequestId;
        this.isLoadingFileNames = true;
        this.saleOrderSvc.getfileName(page, limit, q || '').subscribe(
            (result) => {
                if (requestId !== this.fileNameRequestId) {
                    return;
                }
                const items = Array.isArray(result) ? result : result?.items || [];
                const meta = result?.meta;
                if (meta?.currentPage > 1) {
                    const existingIds = new Set(
                        this.fileNameList.map((file) => file.xlsx_sale_order_files_id)
                    );
                    this.fileNameList = [
                        ...this.fileNameList,
                        ...items.filter(
                            (file) => !existingIds.has(file.xlsx_sale_order_files_id)
                        ),
                    ];
                } else {
                    this.fileNameList = this.keepSelectedFiles(items);
                }
                this.previousPageFileNames = meta?.currentPage || page;
                this.totalPagesFileNames = meta?.totalPages || 1;
                this.isLoadingFileNames = false;
            },
            () => {
                if (requestId === this.fileNameRequestId) {
                    this.isLoadingFileNames = false;
                }
            }
        );
    }

    onFileNameDropdownOpened(): void {
        this.previousPageFileNames = 0;
        this.getListOfFileName(1, 20, this.fileNameSearchId.value || '');
    }

    private keepSelectedFiles(files: any[] = []): any[] {
        const selectedIds = this.fileNameFilter?.value;
        if (!selectedIds || (Array.isArray(selectedIds) && selectedIds.length === 0)) {
            return files;
        }
        const ids = Array.isArray(selectedIds) ? selectedIds : [selectedIds];
        const selected = this.fileNameList.filter(
            (file) =>
                ids.some((id) => id == file.xlsx_sale_order_files_id) &&
                !files.some((item) => item.xlsx_sale_order_files_id == file.xlsx_sale_order_files_id)
        );
        return selected.length ? [...files, ...selected] : files;
    }

    uploadExcel(e): void {
        if (!e.target.files) {
            return;
        }
        const files = e.dataTransfer ? e.dataTransfer.files : e.target.files;
        if (
            !this.uploadFileSvc.excelFileFormats[0]
                .split(', ')
                .find((el) => el === files[0].type)
        ) {
            this.fileInput.nativeElement.value = '';
            this.notify.showError('Should contain only XLSX files');
            return;
        }
        //this.uploadFileSvc.uploadSeveralFile(files, `xlsx-sale-order-files/${this.selectedShop}`);
        this.uploadFileSvc.uploadSeveralFile(
            files,
            `xlsx-sale-order-files/upload/file`
        );
        this.sub$.add(
            this.uploadFileSvc.allFilesLoaded().subscribe((data) => {
                if (!data) {
                    return;
                }
                let file = data[0];
                if (!file) {
                    return;
                }
                file = JSON.parse(file.data);
                this.notify.showSuccessMessage('Uploaded successfully');
                this.fileInput.nativeElement.value = '';
                this.uploadFileSvc.filesLoadedObserver.next(null);
                //this.dialog.close();
            })
        );
    }

    toggleAllEUSelection(control: FormControl, option: MatOption, countries: ICountry[], fieldName= 'name') {
        if (option.selected) {
            const selectedCountries = [];
            countries.map(item => {
                if (item.isEurope) {
                    selectedCountries.push(item[fieldName]);
                }
            })
            control
                .patchValue([...selectedCountries, 0]);
        } else {
            control.patchValue([]);
        }
    }

    toggleAllNonEUSelection(control: FormControl, option: MatOption, countries: ICountry[], fieldName= 'id') {
        if (option.selected) {
            const selectedCountries = [];
            countries.map(item => {
                if (!item.isEurope) {
                    selectedCountries.push(item[fieldName]);
                }
            })
            control
                .patchValue([...selectedCountries, -1]);
        } else {
            control.patchValue([]);
        }
    }

    public toggleSelectAll(control: FormControl, option: MatOption): void {
        if (option.selected) {
            control.patchValue([...this.getAllShops.map((shop) => `${shop.shopName}(${shop.shopId})`), -1]);
        } else {
            control.patchValue([]);
        }
    }

    public getValueShopNameFilter(shop): string{
        return`${shop.shopName}(${shop.shopId})`;
    }

    public isCanCreateLabels(): boolean {
        const orderWithParcel = this.listOfSelectedItemsBody.filter((o) => o.parcel && o.parcel.length > 0);
        return orderWithParcel && orderWithParcel.length > 0;
    }

    public isCanViewLabels(): boolean {
        return this.listOfSelectedItemsBody?.some((order) =>
            order.parcel?.some((parcel) => parcel.labelStatus === ParcelStatus.Created)
        ) ?? false;
    }

    public viewParcelLabels(): void {
        const orderIds = this.listOfSelectedItemsBody.map((o) => o.id);
        this.saleOrderSvc.downloadParcelLabel(orderIds);
    }

    public createLabels(): void {
        const orderIds = this.listOfSelectedItemsBody.map((o) => o.id);
        this.saleOrderSvc.createLabels(orderIds)
            .subscribe({
                next: (res) => {
                    res.data.forEach((label) => {
                        this.updateParcel(label.saleOrderId, label.parcelId, {
                            labelStatus: label.labelStatus });
                    });
                },
                error: (error) => {
                    this.notify.showError('Label can`t be created due to some error');
                },
            });
    }

    public getOrderWithParcel(): string {
        const orderWithParcel = this.listOfSelectedItemsBody?.filter((o) => o.parcel && o.parcel.length > 0) || [];
        return `${this.dataSource.length}/${orderWithParcel.length}`;
    }


    private updateParcel(orderId: number, parcelId: string | number | null, update: Partial<IParcelItem>): void {
        const order = this.listOfSelectedItemsBody.find((o) => o.id === orderId);
        if (!order?.parcel?.length) {
            return;
        }
        if (parcelId === null) {
            order.parcel.forEach((p) => Object.assign(p, update));
            return;
        }
        const parcel = order.parcel.find((p) => String(p.id) === String(parcelId));
        if (parcel) {
            Object.assign(parcel, update);
        }
    }

}
